<script lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { asset } from '../../../helpers.js';
import MetricsCards from '../portfolio/MetricsCards.vue';

export default {
    name: 'Metrics',
    components: { MetricsCards },

    props: {
        heading: { type: String, required: true },
        size: { type: String, required: true },
        editMode: { type: Boolean, required: true, default: false }
    },

    setup() {
        const store = useStore();

        // Reactive computed properties for Vuex data
        const currentDashboardStats = computed(() => ({
            activePriceTargets: computed(() => store.getters['price_targets/getActivePriceTargetsAmount']),
            analyses: computed(() => store.getters['contentstreams/all']?.dashboard?.meta?.total || 0),
            activeTrades: computed(() => store.getters['trades/get']?.data?.meta?.total || 0)
        }));

        const nameOfUser = computed(() => store.getters['user/get']?.name);

        // Fetch active price targets if not already loaded
        if (!store.getters['price_targets/getActivePriceTargetsAmount']) {
            store.dispatch('price_targets/fetchActivePriceTargetsAmount');
        }

        const cardObjects = computed(() => [
            {
                icon: asset('hkcm/images/target-04.svg', 'public'),
                number: currentDashboardStats.value.activePriceTargets,
                title: 'metrics_title_active_pricetargets',
                description: 'metrics_description_active_pricetargets',
                link: null
            },
            {
                icon: asset('hkcm/images/analyse-01.svg', 'public'),
                number: currentDashboardStats.value.analyses,
                title: 'metrics_title_your_analyses',
                description: 'metrics_description_your_analyses',
                link: 'dashboard/markets'
            },
            {
                icon: asset('hkcm/images/trades-01.svg', 'public'),
                number: currentDashboardStats.value.activeTrades,
                title: 'metrics_title_active_Trades',
                description: 'metrics_description_active_trades',
                link: 'dashboard/trades'
            }
        ]);

        return {
            nameOfUser,
            cardObjects
        };
    }
};
</script>

<template>
    <MetricsCards :edit-mode="editMode" :size="size" :title="heading" :description="`${$t('welcome_to_hkcm')} ${nameOfUser}!`" :card-objects="cardObjects" />
</template>
